import {useContext, useRef, useEffect} from "preact/hooks";
import { Recovery } from "../index";
import styles from "./Step.module.css"
import Input from "../Input";
import Button from "../Button";
import useStepRequest from "../Hooks/useStepRequest";

const EmailStep = () => {
  const {setEmail, setError, switchType} = useContext(Recovery)
  const { step1 } = useStepRequest()

  const emailInput = useRef(null)

  useEffect(() => {
    if(emailInput.current){
      emailInput.current.focus()
    }
  }, [emailInput])


  useEffect(() => {
    document.addEventListener('keydown', enterListener)
    document.addEventListener('click', clickHandler)
    return () => {
      document.removeEventListener('keydown', enterListener)
      document.removeEventListener('click', clickHandler)
    }
  }, [])

  const enterListener = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      sumbitStep()
    }
  }

  const clickHandler = (e) => {
    const id = e.target.getAttribute('id')
    if (id === 'switchToPhone') {
      switchType('phone')
    }
  }

  const emailValidation = (email) => {
    const regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
    return regex.test(email)
  }

  const sumbitStep = () => {
    const _email = emailInput.current.value
    const valid = emailValidation(_email)
    const isEmpty = _email
    if(!isEmpty) {
      setError('Вы ничего не ввели')
      return;
    }
    if(!valid) {
      setError('Некорректный email')
      return
    }
    setEmail(_email)
    step1(_email)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_description}>
        Для восстановления доступа введите email, указанный при регистрации
      </div>
      <Input
        label='Электронная почта'
        id='recoveryPhone'
        placeHolder='Введите email'
        inputRef={emailInput}
      />
      <Button name='ДАЛЕЕ' onClick={sumbitStep} />
      <div className={styles.grecaptcha}>
        This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target='_blank' rel='noopener noreferrer'>Privacy
          Policy</a> and <a href="https://policies.google.com/terms" target='_blank' rel='noopener noreferrer'>Terms of Service</a> apply.
      </div>
    </div>
  );
};

export default EmailStep;